import { queryAction } from './../../../action-patterns';
import AuthService from './../../../services/api/auth';

export function loginAction(data) {
    return dispatch => {
        const retrieveData = AuthService.login(data.email, data.password);
        return queryAction(retrieveData, 'LOGIN_REQUEST', 'LOGIN_SUCCESS_LOADING', 'LOGIN_ERROR').run(dispatch);
    };
}

export function setStep(step) {
    window.VULOG_CURRENT_STEP = step;
    return {
        type: `STEP_POSITION`,
        payload: step,
    };
}

export function populateForm(data, type) {
    return {
        type: `@@redux-form-${type}/SET_DATA`,
        payload: data,
    };
}
